import React from "react";
import NoImage from "../../Assets/images/no-image.png";

const overlayOf = (item) => {
  if (item.is_out_of_stock) return { text: "Out of stock", tone: "stock" };
  if (item.is_temporarily_unavailable) return { text: "Off for today", tone: "today" };
  return null;
};

export default function ProductImage({ item }) {
  const overlay = overlayOf(item);
  return (
    <div className={overlay ? undefined : "new-arrivals-img-contnent"}>
      <a className="pc-image-link" href={`/productID/${item.id}`}>
        {overlay && (
          <div className="pc-overlay">
            <strong className={`pc-overlay__tag pc-overlay__tag--${overlay.tone}`}>{overlay.text}</strong>
          </div>
        )}
        <img
          height="300"
          className="img-fluid pc-image"
          src={item.images.length ? item.images[0].image : NoImage}
          alt=""
        />
      </a>
    </div>
  );
}
